module.exports = __webpack_public_path__ + "assets/music/rock/Self-Decieved by XTaKeRuX.ogg";